const breakPoint = 750;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();





// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};


// ------------------------------------------------------------------------
// mainSlider
// ----- BOTH
// ------------------------------------------------------------------------
const mainSlider = () => {
  $('.slider').slick({
    autoplay: true,
    autoplauSpeed: 5000,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    centerMode: false,
    variableWidth: true,
    focusOnSelect: true,
    arrows: false,
    dots: true,
    responsive:[
      {
          breakpoint: 768,
          settings:{
              slidesToShow:1,
          }
      },
    ]
  });
};


// ------------------------------------------------------------------------
// headerResize
// ----- BOTH
// ------------------------------------------------------------------------
const headerResize = () => {
  $(window).on("scroll load", function() {
    let scrollHeight = $(this).scrollTop();
    if (scrollHeight > 200) {
      $(".st-Header").addClass("scrolled");
      $(".st-Header_Inner").addClass("scrolled");
    } else {
      $(".st-Header").removeClass("scrolled");
      $(".st-Header_Inner").removeClass("scrolled");
    }
  });
};


// ------------------------------------------------------------------------
// togglePagetop
// ----- BOTH
// ------------------------------------------------------------------------
const togglePagetop = () => {
  $(window).on("load scroll", function() {
    let docHeight = $('body').height();
    let footerHeight = 87;
    let scrollHeight = $(this).scrollTop();
    windowHeight = window.innerHeight;
    if (scrollHeight > 300) {
      $(".st-Pagetop").addClass("visible");
    } else {
      $(".st-Pagetop").removeClass("visible");
    }
    if ( windowWidth > 750) {
      if(footerHeight > docHeight - scrollHeight - windowHeight) {
        $(".st-Pagetop").css({"bottom":"107px","position":"absolute"});
      } else {
        $(".st-Pagetop").css({"bottom":"20px","position":"fixed"});
      }
    }
  });
};


// ------------------------------------------------------------------------
// toggleMenu
// ----- BOTH
// ------------------------------------------------------------------------
const toggleMenu = () => {
  $('.st-Header_Hamburger > button').on('click', function() {
    $(this).toggleClass("close");
    $(".st-Header_Hamburger").toggleClass("open");
    $(".st-Header_Slide").toggleClass("open");
  });
};


// ------------------------------------------------------------------------
// toggleAccordion
// ----- BOTH
// ------------------------------------------------------------------------
const toggleAccordion = () => {
  $(".rec-List li a").on("click", function() {
    $(this).prev().toggleClass("open");
    $(this).next().slideToggle(400);
  });
  $(".rec-List li button").on("click", function() {
    $(this).toggleClass("open");
    $(this).next().next().slideToggle(400);
  });
  $(window).on("load", function() {
    let hash = location.hash;
    if(hash) {
      let target = $(hash).parent();
      $(target).children("button").toggleClass("open");
      $(target).children(".accordion").slideToggle(400);
      $("html,body").animate({scrollTop:$(hash).offset().top});
    }
  });
};

// ------------------------------------------------------------------------
// toggleAccordionWorks
// ----- BOTH
// ------------------------------------------------------------------------
const toggleAccordionWorks = () => {
  $(".story a, .chronology a").on("click", function() {
    $(this).parent().toggleClass("open");
    $(this).prev().toggleClass("open");
    $(this).next().slideToggle(400);
  });
  $(".story button, .chronology button").on("click", function() {
    $(this).parent().toggleClass("open");
    $(this).toggleClass("open");
    $(this).next().next().slideToggle(400);
  });
};

// ------------------------------------------------------------------------
// toggleAccordionNews
// ----- BOTH
// ------------------------------------------------------------------------
const toggleAccordionNews = () => {
  if(windowWidth <= breakPoint) {
    $(".nws-Sidebar").on("click", function() {
      $(this).children(".accordion").slideToggle(400);
      $(this).toggleClass("open");
    });
  }
};

// ------------------------------------------------------------------------
// toggleAccordionYotalog
// ----- BOTH
// ------------------------------------------------------------------------
const toggleAccordionYotalog = () => {
  if(windowWidth <= breakPoint) {
    $(".yot-Archive").on("click", function() {
      $(this).children(".accordion").slideToggle(400);
      $(this).toggleClass("open");
      $(this).children(".title").children("h3").toggleClass("open");
      $(this).children(".title").children("p").toggleClass("open");
    });
    $(".yot-Sidebar").on("click", function() {
      $(this).children(".accordion").slideToggle(400);
      $(this).toggleClass("open");
    });
  }
};

// ------------------------------------------------------------------------
// togglePlay
// ----- BOTH
// ------------------------------------------------------------------------
const togglePlay = () => {
  let flag = 1;
  $(".movie-toggle video").on("click", function() {
    if(flag == 0) {
      console.log(flag);
      this.pause();
      flag = 1;
    } else {
      this.play();
      flag = 0;
      console.log(flag);
    }
    $(this).parent().toggleClass("play");
  });
};

// ------------------------------------------------------------------------
// beforeValidate
// ----- BOTH
// ------------------------------------------------------------------------
const beforeValidate = () => {
  $(".before-form button").on("click", function() {
    if($(".before-form #check").prop('checked') == true) {
      location.href = location.href+"form/";
      console.log(location.href+"form/");
      return false;
    } else {
      $('.before-form .error').css('display','block');
      return false;
    }
  });
};

export {
  anchorLink,
  mainSlider,
  headerResize,
  togglePagetop,
  toggleMenu,
  toggleAccordion,
  toggleAccordionWorks,
  toggleAccordionNews,
  toggleAccordionYotalog,
  beforeValidate,
  togglePlay,
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js